module.exports = __webpack_public_path__ + "4dda6faefc1b888b334626ffc745a5d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-1920-7.jpg
// module id = 437
// module chunks = 0